var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFavicon = function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.078 12.973.004 7.292-7.394.006c.114-.252 5.702-5.652 6.428-6.402.17-.176.772-.814.962-.896ZM6.662 6.411c.154-.152.796-.862.938-.854l.004 14.658c-.136-.036-1.64-1.56-1.89-1.804-.624-.608-1.28-1.274-1.864-1.846-.192-.188-3.584-3.49-3.696-3.69l6.508-6.464Zm8.416 6.402c-.168-.092-.812-.748-.976-.918l-3.698-3.68c-.31-.32-.614-.604-.922-.912L7.738 5.577c-.058-.07-.042-.016-.068-.12l7.412.008-.004 7.348Zm4.67-4.486.038-7.512-7.538.014-4.2 4.176c-.33.336-.366.444-.628.444L.108 5.447l.014 14.844c2.014.04 4.076 0 6.102 0 1.67 0 1.196-.142 1.826.448 1.118 1.05 2.294 2.296 3.43 3.396.136.134.242.23.388.372.602.592.256.432 1.856.432h3.032c.936 0 2.136.066 3.04-.008.046-.658.008-1.446.008-2.118v-4.152c0-1.32.148-.994-.474-1.614-.192-.19-4.068-3.922-4.18-4.172l4.032-4.04c.082-.082.462-.486.566-.508Z",
    fill: "currentcolor",
    fillRule: "nonzero"
  })));
};

export default SvgFavicon;